module.exports = __webpack_public_path__ + "img/camera.7041d823.png";